module.exports = __webpack_public_path__ + "img/wirvsvirus.b1df6f96.png";